
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSelector() {
    const { i18n } = useTranslation();

    const changeLanguage = (e) => {
        i18n.changeLanguage(e.target.value);
    };

    return (
        <div style={{ padding: '10px' }}>
            <select className={"select"} style={{width: "100px"}} onChange={changeLanguage} value={i18n.language}>
                <option value="en">English</option>
                <option value="pt">Português</option>
                <option value="es">Español</option>
            </select>
        </div>
    );
}
